import { useState } from 'react';

import { useTranslation } from 'react-i18next';

export enum DocumentStatusSelectType {
  ACTIVE = 'active',
  ARCHIVED = 'archived',
}

export function useDocumentStatus() {
  const [selectedView, setSelectedView] = useState<DocumentStatusSelectType>(
    DocumentStatusSelectType.ACTIVE,
  );
  const { t } = useTranslation(['documents']);

  const documentStatusSelectTypeLabel = [
    {
      value: DocumentStatusSelectType.ACTIVE,
      label: t('status.active'),
    },
    {
      value: DocumentStatusSelectType.ARCHIVED,
      label: t('status.archived'),
    },
  ];

  const handleViewChange = (view: DocumentStatusSelectType | null) => {
    if (!view) {
      setSelectedView(DocumentStatusSelectType.ACTIVE);
    } else {
      setSelectedView(view);
    }
  };

  return {
    documentStatusSelectTypeLabel,
    selectedView,
    handleViewChange,
  };
}
